import { render, staticRenderFns } from "./Overall.vue?vue&type=template&id=1b6a0923&scoped=true&"
import script from "./Overall.vue?vue&type=script&lang=js&"
export * from "./Overall.vue?vue&type=script&lang=js&"
import style0 from "./Overall.css?vue&type=style&index=0&id=1b6a0923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a0923",
  null
  
)

export default component.exports